/* House of Binti homepage v2 shared script (builder HA, HOMEPAGE-SPEC 4.3). window.HPv2 + 'hp:ready' once; later copies re-scan.
 * Delegates addToCart/money/track to window.PDPv2 when present, else the same contract on the theme cart drawer + pubsub.
 * Attributes: a[data-hp-add][data-variant-id|data-handle(+data-preselect-id)]; [data-hp-track] (+data-hp-list/-pos/-<key>; details=open, form=submit);
 * [data-hp-list-view]; tabs [data-hp-tabset] > [role=tab][aria-controls][data-handle][data-list][data-url] + [data-hp-panel]
 * + a[data-hp-view-all]; [data-hp-bag-count] [data-hp-bag-label] [data-hp-open-cart]; [data-hp-dialog-open=id] [data-hp-dialog-close]. */
(() => {
  'use strict';

  if (window.HPv2) {
    try { window.HPv2.scan(document); } catch (e) { /* noop */ }
    return;
  }

  const d = document;
  const $ = (s, r = d) => (r ? r.querySelector(s) : null);
  const $$ = (s, r = d) => (r ? Array.from(r.querySelectorAll(s)) : []);
  const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = () => !!(navigator.connection && navigator.connection.saveData);
  const idle = (fn) => (window.requestIdleCallback ? window.requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 300));
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const ICON = {
    x: 'M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z',
    left: 'M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z',
    right: 'M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z',
  };
  const svg = (k) => `<svg class="hp-icon" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="${ICON[k]}"/></svg>`;

  /* ------------------------------------------------------------ events, analytics, money */
  const on = (name, fn) => {
    const h = (e) => { try { fn(e.detail || {}, e); } catch (err) { console.error('[HPv2]', name, err); } };
    d.addEventListener(name, h);
    return () => d.removeEventListener(name, h);
  };
  const emit = (name, detail = {}) => { try { d.dispatchEvent(new CustomEvent(name, { detail })); } catch (e) { /* noop */ } };
  const pdp = () => (window.PDPv2 && window.PDPv2 !== api ? window.PDPv2 : null);

  function track(name, data) {
    try {
      const payload = Object.assign({}, data || {});
      const P = pdp();
      if (P && typeof P.track === 'function') { P.track(name, payload); return; }
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, payload);
      } catch (e) { /* noop */ }
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, payload));
      } catch (e) { /* noop */ }
    } catch (e) { /* never throws */ }
  }

  // Shop money format ("Rs. {{amount}}"), trailing zeros dropped, "Rs." shown as the rupee sign (same as PDPv2.money).
  function money(cents) {
    try {
      const P = pdp();
      if (P && typeof P.money === 'function') return P.money(cents);
    } catch (e) { /* fall through */ }
    const value = Math.round(Number(cents) || 0);
    const whole = value % 100 === 0;
    const holder = $('[data-hp-money-format]');
    const fmt = String((holder && holder.dataset.hpMoneyFormat) || 'Rs. {{amount}}').replace(/<[^>]*>/g, '');
    const num = (dec, th, dp) => {
      const parts = (value / 100).toFixed(dec).split('.');
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[1] && dec > 0 ? int + dp + parts[1] : int;
    };
    const out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      if (key === 'amount_no_decimals') return num(0, ',', '.');
      if (key === 'amount_with_comma_separator') return num(whole ? 0 : 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return num(0, '.', ',');
      return num(whole ? 0 : 2, ',', '.');
    });
    return out.replace(/Rs\.?\s*/g, '₹').replace(/₹\s+/g, '₹').trim();
  }

  /* ------------------------------------------------------------ live region */
  function liveEl() {
    let el = d.getElementById('hp-live');
    if (!el && d.body) {
      el = d.createElement('div');
      el.id = 'hp-live';
      el.className = 'pdp-sr-only';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      d.body.appendChild(el);
    }
    return el;
  }
  function live(msg) {
    // An add that opened the cart drawer is announced inside its dialog (drawer.pdpAnnounce, pdp-cart-nudge):
    // #hp-live sits outside that aria-modal dialog, so screen readers skip it there, or read the add twice.
    const c = cartUI();
    if (c && c.pdpSaidAt && Date.now() - c.pdpSaidAt < 4000) return;
    const el = liveEl();
    if (!el) return;
    el.textContent = '';
    setTimeout(() => { el.textContent = msg; }, 80);
  }

  /* ------------------------------------------------------------ cart */
  const pubOk = () => typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  const pub = (key, data) => { try { if (pubOk() && PUB_SUB_EVENTS[key]) window.publish(PUB_SUB_EVENTS[key], data); } catch (e) { /* noop */ } };
  const cartUI = () => d.querySelector('cart-drawer') || d.querySelector('cart-notification');

  function lines(items) {
    return (Array.isArray(items) ? items : [items]).filter(Boolean).map((i) => {
      const l = { id: Number(i.id), quantity: Math.max(1, Number(i.quantity) || 1) };
      if (i.properties && typeof i.properties === 'object') l.properties = i.properties;
      return l;
    }).filter((l) => l.id > 0);
  }

  async function ownAdd(list) {
    const cart = cartUI();
    const body = { items: list };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const url = (window.routes && window.routes.cart_add_url) || `${root()}cart/add`;
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    });
    let json = {};
    try { json = await res.json(); } catch (e) { json = { status: res.status, description: 'Could not add to cart' }; }
    if (!res.ok || json.status) {
      pub('cartError', { source: 'hp-v2', productVariantId: list[0].id, errors: json.errors || json.description, message: json.message });
      const err = new Error(json.description || json.message || 'Could not add to cart');
      err.response = json;
      throw err;
    }
    if (!cart) {
      window.location = (window.routes && window.routes.cart_url) || `${root()}cart`;
      return json;
    }
    pub('cartUpdate', { source: 'hp-v2', productVariantId: list[0].id, cartData: json });
    try {
      cart.renderContents(json); // re-renders the drawer (so pdp-cart-nudge shows the offer line) and opens it
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      // Announce the add and the offer line inside the drawer dialog, after the theme's cart.js re-render
      if (typeof cart.pdpAnnounce === 'function') {
        const items = Array.isArray(json.items) ? json.items : (json.product_title || json.title ? [json] : []);
        cart.pdpAnnounce(items.map((i) => i.product_title || i.title));
      }
    } catch (e) {
      console.error('[HPv2] cart drawer render failed', e);
    }
    return json;
  }

  async function addToCart(items, opts = {}) {
    const list = lines(items);
    if (!list.length) throw new Error('HPv2.addToCart: no valid items');
    const name = String((opts && opts.list) || 'home');
    const P = pdp();
    const json = P && typeof P.addToCart === 'function'
      ? await P.addToCart(list, { source: `home:${name}` })
      : await ownAdd(list);
    const cart = cartUI();
    if (cart && opts.trigger && typeof cart.setActiveElement === 'function') cart.setActiveElement(opts.trigger);
    emit('hp:added', { items: list, list: name, position: opts.position, cart: json });
    return json;
  }

  /* ------------------------------------------------------------ bag count */
  let bagTimer = 0;
  function paintBag(n) {
    $$('[data-hp-bag-count]').forEach((el) => { el.textContent = String(n); el.hidden = n < 1; });
    $$('[data-hp-bag-label]').forEach((el) => el.setAttribute('aria-label', n < 1 ? 'Bag' : `Bag, ${n} ${n === 1 ? 'item' : 'items'}`));
  }
  function refreshBag(count) {
    if (typeof count === 'number') { paintBag(count); return; }
    clearTimeout(bagTimer);
    bagTimer = setTimeout(async () => {
      if (!$('[data-hp-bag-count], [data-hp-bag-label]')) return;
      try {
        const base = (window.routes && window.routes.cart_url) || `${root()}cart`;
        const r = await fetch(`${base}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const c = await r.json();
        paintBag(Number(c.item_count) || 0);
      } catch (e) { /* keep the server-rendered count */ }
    }, 150);
  }

  /* ------------------------------------------------------------ card quick add */
  function cardCtx(el) {
    const card = el && el.closest ? el.closest('[data-hp-card]') : null;
    if (!card) return { card: null, list: (el && el.dataset && el.dataset.hpList) || 'home', position: Number(el && el.dataset && el.dataset.hpPos) || 0 };
    const name = card.querySelector('.hp-card__link');
    const listEl = card.closest('[data-hp-cards]');
    return {
      card,
      list: card.dataset.list || 'home',
      position: Number(card.dataset.position) || 0,
      productId: Number(card.dataset.productId) || 0,
      handle: card.dataset.handle,
      price: Number(card.dataset.price) || 0,
      title: name ? name.textContent.trim() : '',
      // hp-card no longer prints .hp-card__offer (COLLECTION-SPEC 5.3, CL-C): the card's offer badge (snippets/card-badges)
      // carries the same wording ("Buy 1 Get 1" free, "2 for 1" pair, none when hidden or sold out).
      offer: (card.querySelector('.hp-card__offer') || {}).textContent
        || ((b) => (b ? (b.textContent.trim() === '2 for 1' ? '2 for the price of one' : 'Buy 1, get 1 free') : ''))(card.querySelector('.cb-badge--offer')),
      // The sheet follows the card's own list (its wording and MRP mode), not the first list on the page.
      mrp: listEl ? listEl.dataset.hpMrp : undefined,
    };
  }
  function setBusy(btn, busy) {
    if (busy) {
      btn.dataset.hpLabel = btn.getAttribute('aria-label') || '';
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-label', 'Adding');
    } else {
      btn.removeAttribute('aria-busy');
      if (btn.dataset.hpLabel !== undefined) btn.setAttribute('aria-label', btn.dataset.hpLabel);
    }
  }
  function cardMsg(card, msg) {
    if (!card) return;
    let p = card.querySelector('.hp-card__err');
    if (!msg) { if (p) p.remove(); return; }
    if (!p) {
      p = d.createElement('p');
      p.className = 'hp-card__err';
      p.setAttribute('role', 'alert');
      const row = card.querySelector('.hp-card__row');
      if (row) row.insertAdjacentElement('afterend', p); else card.appendChild(p);
    }
    p.textContent = msg;
  }
  async function cardAdd(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    const ctx = cardCtx(btn);
    const vid = Number(btn.dataset.variantId) || 0;
    if (!vid) {
      if (btn.dataset.handle) openQuickAdd(btn.dataset.handle, { list: ctx.list, position: ctx.position, trigger: btn, variant: Number(btn.dataset.preselectId) || 0 });
      return;
    }
    setBusy(btn, true);
    cardMsg(ctx.card, '');
    try {
      await addToCart([{ id: vid, quantity: 1 }], { list: ctx.list, position: ctx.position, trigger: btn });
      track('hp_quick_add', { list: ctx.list, product_id: ctx.productId, variant_id: vid, position: ctx.position, price: ctx.price / 100, currency: 'INR' });
      live(`Added ${ctx.title || 'piece'} to bag`);
    } catch (e) {
      cardMsg(ctx.card, 'Could not add this piece. Try again.');
    } finally {
      setBusy(btn, false);
    }
  }

  /* ------------------------------------------------------------ dialogs (sheets) */
  function openDialog(dlg, trigger) {
    if (!dlg) return false;
    dlg.__hpTrigger = trigger || d.activeElement;
    if (!dlg.__hpBound) {
      dlg.__hpBound = true;
      dlg.addEventListener('click', (e) => { if (e.target === dlg) closeDialog(dlg); });
      dlg.addEventListener('close', () => {
        d.documentElement.classList.remove('hp-lock');
        emit('hp:sheet', { open: false, kind: dlg.dataset.hpKind || dlg.id || 'sheet' });
        const t = dlg.__hpTrigger;
        dlg.__hpTrigger = null;
        if (t && t.isConnected && typeof t.focus === 'function') { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
      });
    }
    try {
      if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    } catch (e) { dlg.setAttribute('open', ''); }
    d.documentElement.classList.add('hp-lock');
    emit('hp:sheet', { open: true, kind: dlg.dataset.hpKind || dlg.id || 'sheet' });
    return true;
  }
  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function' && dlg.open) dlg.close();
    else if (dlg.hasAttribute('open')) { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); }
  }

  /* ------------------------------------------------------------ quick-add sheet */
  const products = new Map();
  function getProduct(handle) {
    if (!products.has(handle)) {
      const p = fetch(`${root()}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then((r) => { if (!r.ok) throw new Error(`status ${r.status}`); return r.json(); });
      p.catch(() => products.delete(handle));
      products.set(handle, p);
    }
    return products.get(handle);
  }
  const isSizeName = (n) => /size/i.test(n);
  const isFinishName = (n) => /finish|colou?r|metal|plating|tone/i.test(n);
  function optLabel(n) {
    const l = String(n).toLowerCase();
    if (l.includes('size')) {
      if (l.includes('ring') && l.includes('indian')) return 'Ring size (Indian)';
      if (l.includes('indian')) return 'Size (Indian)';
      return l.includes('ring') ? 'Ring size' : 'Size';
    }
    if (l.includes('finish')) return 'Finish';
    if (/colou?r/.test(l)) return 'Colour';
    if (l.includes('metal')) return 'Metal';
    return String(n);
  }
  function finishLabel(v) {
    const l = String(v).toLowerCase();
    if (l.includes('rose')) return 'Rose gold-plated';
    if (l.includes('gold')) return 'Gold-plated';
    return String(v);
  }
  function tone(v) {
    const l = String(v).toLowerCase();
    if (l.includes('rose')) return 'rose';
    if (l.includes('gold')) return 'gold';
    if (l.includes('silver') || l.includes('rhodium')) return 'silver';
    return '';
  }
  const imgUrl = (src, w) => {
    if (!src) return '';
    const s = typeof src === 'string' ? src : src.src || '';
    return s ? `${s}${s.includes('?') ? '&' : '?'}width=${w}` : '';
  };
  // Same switch as pdp-price: shop metafield pdp.mrp_mode 'hide' (or 'hidden') removes strikes.
  const mrpHidden = (ctx) => {
    const el = $('[data-hp-mrp]');
    const m = String((ctx && ctx.mrp) || (el && el.dataset.hpMrp) || '').trim().toLowerCase();
    return m === 'hide' || m === 'hidden';
  };
  function priceHtml(v, from, ctx) {
    const sale = !mrpHidden(ctx) && v.compare_at_price && v.compare_at_price > v.price;
    let h = `<span class="hp-qa__now">${from ? 'From ' : ''}${sale ? '<span class="pdp-sr-only">Sale price </span>' : ''}${esc(money(v.price))}</span>`;
    if (sale) {
      const off = Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
      h += `<span class="hp-qa__was"><span class="pdp-sr-only">MRP </span><s>${esc(money(v.compare_at_price))}</s></span>`;
      if (off > 0) h += `<span class="hp-qa__off">${off}% OFF</span>`;
    }
    return { html: h, sale };
  }

  let QA = null; // { dlg, body, msg, add, s: state }
  function qaBuild() {
    if (QA) return QA;
    const dlg = d.createElement('dialog');
    dlg.className = 'pdp-sheet hp-sheet hp-qa';
    dlg.dataset.hpKind = 'quick_add';
    dlg.setAttribute('aria-labelledby', 'hp-qa-name');
    dlg.innerHTML = `<div class="hp-sheet__in">
      <div class="hp-sheet__head"><p class="hp-sheet__title">Choose options</p><button type="button" class="hp-sheet__close" data-hp-qa-close aria-label="Close">${svg('x')}</button></div>
      <div class="hp-sheet__body" data-hp-qa-body></div>
      <div class="hp-sheet__foot"><p class="hp-qa__msg" data-hp-qa-msg role="status" aria-live="polite"></p><button type="button" class="pdp-btn pdp-btn--primary" data-hp-qa-add>Add to cart</button></div>
    </div>`;
    d.body.appendChild(dlg);
    QA = { dlg, body: $('[data-hp-qa-body]', dlg), msg: $('[data-hp-qa-msg]', dlg), add: $('[data-hp-qa-add]', dlg), s: null };
    $('[data-hp-qa-close]', dlg).addEventListener('click', () => closeDialog(dlg));
    QA.add.addEventListener('click', () => qaAdd());
    dlg.addEventListener('change', (e) => {
      const input = e.target;
      if (!input || input.type !== 'radio' || !QA.s) return;
      const i = Number(input.dataset.i);
      QA.s.sel[i] = input.value;
      qaReconcile(i);
      qaPaint();
      qaMsg('');
    });
    dlg.addEventListener('close', () => { QA.s = null; });
    return QA;
  }
  function qaMsg(text, retry) {
    if (!QA) return;
    QA.msg.textContent = text || '';
    if (text && retry) {
      const b = d.createElement('button');
      b.type = 'button';
      b.className = 'hp-link';
      b.textContent = 'Try again';
      b.addEventListener('click', retry);
      QA.msg.appendChild(b);
    }
  }
  const matches = (v, sel, skip) => sel.every((val, j) => j === skip || val == null || v.options[j] === val);
  function valueAvailable(i, val) {
    const s = QA.s;
    return s.p.variants.some((v) => v.available && v.options[i] === val && matches(v, s.sel, i));
  }
  function qaVariant() {
    const s = QA.s;
    if (s.sel.some((x) => x == null)) return null;
    return s.p.variants.find((v) => v.options.every((val, j) => val === s.sel[j])) || null;
  }
  // After option `changed` moves, a non-size option whose value no longer has stock moves to its first available
  // value; a size that no longer has stock is cleared (sizes are never picked for the shopper).
  function qaReconcile(changed) {
    const s = QA.s;
    s.opts.forEach((o, j) => {
      if (j === changed || s.sel[j] == null || valueAvailable(j, s.sel[j])) return;
      if (o.isSize) { s.sel[j] = null; return; }
      const next = o.values.find((val) => valueAvailable(j, val));
      s.sel[j] = next == null ? null : next;
    });
  }
  function qaOpen(p, ctx) {
    const opts = (p.options || []).map((o, i) => {
      const name = typeof o === 'string' ? o : o.name;
      const values = typeof o === 'string'
        ? Array.from(new Set(p.variants.map((v) => v.options[i])))
        : (o.values || []);
      const skip = values.length === 1 && values[0] === 'Default Title';
      return { name, label: optLabel(name), isSize: !skip && isSizeName(name), isFinish: isFinishName(name), values, skip };
    });
    const s = { p, ctx, opts, sel: opts.map((o) => (o.skip ? o.values[0] : null)), busy: false };
    QA.s = s;
    // Non-size options start on their first available value, in order; sizes start unchosen. A band card (CB-04,
    // data-preselect-id) starts on its own in-band variant's non-size values, so the sheet shows the card's price.
    const pre = ctx.preselect ? p.variants.find((v) => v.id === ctx.preselect && v.available) : null;
    opts.forEach((o, i) => {
      if (o.isSize || o.skip) return;
      if (pre) { s.sel[i] = pre.options[i]; return; }
      const first = o.values.find((val) => valueAvailable(i, val));
      s.sel[i] = first == null ? null : first;
    });
    // A card's own offer line already follows its list's wording (empty when hidden or not an offer piece).
    const offer = ctx.card ? ctx.offer : offerLine(p);
    // The name and Size guide links open the PDP on the preselected band variant too (cbfix2), as the card's links do.
    const base = p.url || `${root()}products/${p.handle}`;
    const url = pre ? `${base}${base.includes('?') ? '&' : '?'}variant=${pre.id}` : base;
    let h = `<div class="hp-qa__prod">
      <img class="hp-qa__thumb" data-hp-qa-img src="${esc(imgUrl(p.featured_image, 144))}" alt="" width="72" height="72">
      <div><p class="hp-qa__name" id="hp-qa-name"><a href="${esc(url)}" data-hp-track="hp_card_click" data-hp-list="${esc(ctx.list)}" data-hp-pos="${esc(ctx.position)}" data-hp-product_id="${esc(p.id)}">${esc(p.title)}</a></p>
      <p class="hp-qa__price" data-hp-qa-price></p>${offer ? `<p class="hp-qa__offer">${esc(offer.trim())}</p>` : ''}</div></div>`;
    opts.forEach((o, i) => {
      if (o.skip) return;
      h += `<fieldset class="hp-qa__opt" data-i="${i}"><legend class="hp-qa__legend"><span>${esc(o.label)}</span><span class="hp-qa__picked" data-hp-qa-picked="${i}"></span></legend><div class="hp-qa__vals">`;
      o.values.forEach((val, k) => {
        const id = `hp-qa-${i}-${k}`;
        const label = o.isFinish ? finishLabel(val) : val;
        const t = o.isFinish ? tone(val) : '';
        h += `<span class="hp-qa__val"><input type="radio" id="${id}" name="hp-qa-${i}" value="${esc(val)}" data-i="${i}">`
          + `<label class="hp-qa__chip" for="${id}">${t ? `<i class="hp-qa__dot hp-qa__dot--${t}" aria-hidden="true"></i>` : ''}<span>${esc(label)}</span><span class="pdp-sr-only" data-hp-so hidden>, sold out</span></label></span>`;
      });
      h += '</div>';
      if (o.isSize) h += `<p class="hp-qa__guide"><a class="hp-link" href="${esc(url)}">Size guide<span class="pdp-sr-only">, on the product page</span></a></p>`;
      h += '</fieldset>';
    });
    QA.body.innerHTML = h;
    QA.body.removeAttribute('aria-busy');
    QA.add.disabled = false;
    QA.add.hidden = false;
    qaPaint();
  }
  function offerLine(p) {
    const tags = p.tags || [];
    if (!tags.includes('BOGO') || tags.includes('BOGO-EXCLUDE')) return '';
    const el = $('[data-hp-wording]');
    const w = el ? el.dataset.hpWording : 'free';
    if (w === 'hidden') return '';
    return w === 'pair' ? '2 for the price of one' : 'Buy 1, get 1 free';
  }
  function qaPaint() {
    const s = QA.s;
    if (!s) return;
    s.opts.forEach((o, i) => {
      if (o.skip) return;
      $$(`input[data-i="${i}"]`, QA.body).forEach((input) => {
        const ok = valueAvailable(i, input.value);
        input.disabled = !ok;
        input.checked = s.sel[i] === input.value;
        const so = $('[data-hp-so]', input.nextElementSibling);
        if (so) so.hidden = ok;
      });
      const picked = $(`[data-hp-qa-picked="${i}"]`, QA.body);
      if (picked) {
        const v = s.sel[i];
        picked.textContent = v == null ? (o.isSize ? 'Choose a size' : `Choose ${o.label.toLowerCase()}`) : (o.isFinish ? finishLabel(v) : v);
      }
    });
    const v = qaVariant();
    let shown = v;
    let from = false;
    if (!shown) {
      const pool = s.p.variants.filter((x) => x.available && matches(x, s.sel, -1));
      const list = pool.length ? pool : s.p.variants;
      shown = list.slice().sort((a, b) => a.price - b.price)[0];
      from = list.some((x) => x.price !== shown.price);
    }
    const priceEl = $('[data-hp-qa-price]', QA.body);
    if (priceEl && shown) {
      const r = priceHtml(shown, from, s.ctx);
      priceEl.innerHTML = r.html;
      priceEl.classList.toggle('hp-qa__price--sale', r.sale);
    }
    const img = $('[data-hp-qa-img]', QA.body);
    if (img && v && v.featured_image) img.src = imgUrl(v.featured_image, 144);
  }
  async function qaAdd() {
    const s = QA && QA.s;
    if (!s || s.busy) return;
    const missing = s.opts.findIndex((o, i) => s.sel[i] == null);
    if (missing > -1) {
      const o = s.opts[missing];
      qaMsg(o.isSize ? 'Choose a size' : `Choose ${o.label.toLowerCase()}`);
      if (o.isSize) track('hp_size_required', { product_id: s.p.id, list: s.ctx.list });
      const first = $(`fieldset[data-i="${missing}"] input:not(:disabled)`, QA.body);
      if (first) first.focus();
      return;
    }
    const v = qaVariant();
    if (!v || !v.available) { qaMsg('This option is sold out. Choose another.'); return; }
    s.busy = true;
    QA.add.setAttribute('aria-busy', 'true');
    QA.add.textContent = 'Adding';
    qaMsg('');
    try {
      await addToCart([{ id: v.id, quantity: 1 }], { list: s.ctx.list, position: s.ctx.position, trigger: s.ctx.trigger });
      track('hp_quick_add', { list: s.ctx.list, product_id: s.p.id, variant_id: v.id, position: s.ctx.position, price: v.price / 100, currency: 'INR' });
      closeDialog(QA.dlg);
      live(`Added ${s.p.title} to bag`);
    } catch (e) {
      qaMsg('Could not add this piece.', () => qaAdd());
    } finally {
      s.busy = false;
      if (QA) { QA.add.removeAttribute('aria-busy'); QA.add.textContent = 'Add to cart'; }
    }
  }
  let qaSeq = 0;
  function openQuickAdd(handle, opts = {}) {
    if (!handle) return;
    const q = qaBuild();
    const seq = ++qaSeq; // only the latest open may fill the sheet (a slow earlier fetch must not replace it)
    const trigger = opts.trigger || d.activeElement;
    let base = cardCtx(trigger);
    if (base.card && base.handle !== handle) base = { card: null, list: 'home', position: 0 }; // trigger is another product's card
    const ctx = Object.assign(base, { list: opts.list || base.list, position: opts.position || base.position, trigger, preselect: Number(opts.variant) || 0 });
    const current = () => seq === qaSeq && q.dlg.open;
    q.s = null;
    q.body.setAttribute('aria-busy', 'true');
    q.body.innerHTML = '<p class="hp-qa__state" id="hp-qa-name">Loading options</p>';
    q.add.hidden = true;
    qaMsg('');
    openDialog(q.dlg, trigger);
    track('hp_quick_sheet_open', { product_id: ctx.productId || undefined, list: ctx.list });
    const load = () => getProduct(handle).then((p) => {
      if (!current()) return;
      qaOpen(p, ctx);
      const first = $('input:not(:disabled)', q.body);
      if (first && !matchMedia('(hover: none)').matches) first.focus();
    }).catch(() => {
      if (!current()) return;
      q.body.removeAttribute('aria-busy');
      q.body.innerHTML = `<div class="hp-qa__state"><p id="hp-qa-name">Could not load this piece.</p><p><button type="button" class="hp-link" data-hp-qa-retry>Try again</button> or <a class="hp-link" href="${esc(`${root()}products/${handle}`)}">open the product page</a></p></div>`;
      const b = $('[data-hp-qa-retry]', q.body);
      if (b) b.addEventListener('click', () => { q.body.innerHTML = '<p class="hp-qa__state" id="hp-qa-name">Loading options</p>'; load(); });
    });
    load();
  }

  /* ------------------------------------------------------------ tab loader */
  const panels = new Map();
  function fetchCards(handle) {
    if (!handle) return Promise.resolve({ html: '', count: 0 });
    if (!panels.has(handle)) {
      const p = fetch(`${root()}collections/${encodeURIComponent(handle)}?section_id=hp-collection-cards`, { credentials: 'same-origin' })
        .then(async (r) => {
          if (r.status === 404) return { html: '', count: 0 };
          if (!r.ok) throw new Error(`status ${r.status}`);
          const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
          const wrap = doc.querySelector('[data-hp-collection-cards]');
          if (!wrap) throw new Error('no cards section');
          const ul = wrap.querySelector('[data-hp-cards]');
          return { html: ul ? ul.outerHTML : '', count: ul ? Number(ul.dataset.count) || ul.children.length : 0 };
        });
      p.catch(() => panels.delete(handle));
      panels.set(handle, p);
    }
    return panels.get(handle);
  }
  const tabsOf = (r) => $$('[role="tab"]', r);
  const panelOf = (tab) => { const id = tab.getAttribute('aria-controls'); return id ? d.getElementById(id) : null; };
  function handleOf(tab) {
    if (tab.dataset.handle) return tab.dataset.handle;
    const m = String(tab.dataset.url || '').match(/\/collections\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  const tabUrl = (tab) => tab.dataset.url || `${root()}collections/${handleOf(tab)}`;
  function skeleton(n) {
    let li = '';
    for (let i = 0; i < n; i += 1) li += '<li class="pdp-card hp-card hp-skel"><span class="hp-skel__img"></span><span class="hp-skel__bar"></span><span class="hp-skel__bar"></span></li>';
    return `<ul class="pdp-rail hp-rail" role="presentation" aria-hidden="true">${li}</ul>`;
  }
  function fillPanel(panel, html, list) {
    const tpl = d.createElement('template');
    tpl.innerHTML = html.trim();
    const ul = tpl.content.firstElementChild;
    if (!ul) return;
    if (list) {
      ul.dataset.hpListView = list;
      $$('[data-hp-card]', ul).forEach((c) => { c.dataset.list = list; });
      $$('[data-hp-list]', ul).forEach((a) => { a.dataset.hpList = list; });
    }
    panel.innerHTML = '';
    panel.appendChild(ul);
    scan(panel);
  }
  function removeTab(r, tab) {
    const panel = panelOf(tab);
    const wasOn = tab.getAttribute('aria-selected') === 'true';
    const hadFocus = d.activeElement === tab || !!(panel && panel.contains(d.activeElement));
    tab.remove();
    if (panel) panel.remove();
    const rest = tabsOf(r);
    if (!rest.length) { r.hidden = true; return; }
    if (wasOn) selectTab(r, rest[0], { focus: hadFocus }); // keyboard users keep their place in the tablist
    else if (!rest.some((t) => t.tabIndex === 0)) rest[0].tabIndex = 0;
  }
  async function ensurePanel(r, tab) {
    const panel = panelOf(tab);
    if (!panel || panel.querySelector('[data-hp-cards]') || panel.dataset.hpState === 'loading') return;
    const handle = handleOf(tab);
    if (!handle) { removeTab(r, tab); return; }
    if (r.__hpMinH) panel.style.minHeight = `${r.__hpMinH}px`;
    panel.dataset.hpState = 'loading';
    panel.setAttribute('aria-busy', 'true');
    const slow = setTimeout(() => { if (panel.dataset.hpState === 'loading') panel.innerHTML = skeleton(5); }, 60);
    try {
      const res = await fetchCards(handle);
      clearTimeout(slow);
      if (!res.count) { removeTab(r, tab); return; }
      fillPanel(panel, res.html, tab.dataset.list || handle);
      panel.dataset.hpState = 'ready';
      panel.style.minHeight = ''; // the reserve only covers the load; a shorter panel must not keep a gap
      railNav(panel);
    } catch (e) {
      clearTimeout(slow);
      panel.dataset.hpState = 'error';
      panel.style.minHeight = '';
      panel.innerHTML = '<div class="hp-panel-msg" role="status"><span>Could not load these pieces.</span><button type="button" class="pdp-btn pdp-btn--secondary pdp-btn--sm" data-hp-retry>Retry</button></div>';
      const b = $('[data-hp-retry]', panel);
      if (b) b.addEventListener('click', () => { panel.dataset.hpState = ''; ensurePanel(r, tab).then(() => { const t = $('.hp-card__link, [data-hp-retry]', panel); if (t) t.focus(); }); });
    } finally {
      panel.removeAttribute('aria-busy');
    }
  }
  function selectTab(r, tab, o = {}) {
    if (!tab || !tab.isConnected) return;
    const current = tabsOf(r).find((t) => t.getAttribute('aria-selected') === 'true');
    const curPanel = current ? panelOf(current) : null;
    if (curPanel && !curPanel.hidden && curPanel.offsetHeight) r.__hpMinH = Math.max(r.__hpMinH || 0, curPanel.offsetHeight);
    tabsOf(r).forEach((t) => {
      const sel = t === tab;
      t.setAttribute('aria-selected', sel ? 'true' : 'false');
      t.tabIndex = sel ? 0 : -1;
      const p = panelOf(t);
      if (p) p.hidden = !sel;
    });
    // A panel shown again restarts its offer-line animations (hidden is display:none, which cancels them), and one
    // filled while hidden had none to align: rejoin the page phase once per tab change (COLLECTION-SPEC 3.3).
    const shown = panelOf(tab);
    if (shown && window.CardBadges) { try { window.CardBadges.sync(shown); } catch (e) { /* noop */ } }
    $$('[data-hp-view-all]', r).forEach((a) => { a.href = tabUrl(tab); });
    if (o.focus) {
      tab.focus();
      try { tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { /* noop */ }
    }
    const handle = handleOf(tab);
    if (o.user) {
      const label = tab.textContent.trim();
      track('hp_tab_select', { tab: label, handle });
      emit('hp:tab', { tab: label, handle, list: tab.dataset.list || handle });
    }
    ensurePanel(r, tab);
    const p = panelOf(tab);
    if (p) railNav(p);
  }
  function prefetch(r) {
    if (saveData()) return;
    const queue = tabsOf(r).filter((t) => { const p = panelOf(t); return p && !p.querySelector('[data-hp-cards]'); });
    const next = () => {
      const tab = queue.shift();
      if (!tab) return;
      idle(() => {
        if (!tab.isConnected) { next(); return; }
        fetchCards(handleOf(tab)).then((res) => { if (!res.count && tab.isConnected) removeTab(r, tab); }).catch(() => {}).then(next);
      });
    };
    next();
  }
  function initTabs(r) {
    if (r.__hpTabs) return;
    r.__hpTabs = true;
    const tabs = tabsOf(r);
    if (!tabs.length) return;
    const on1 = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];
    tabs.forEach((t) => {
      t.tabIndex = t === on1 ? 0 : -1;
      if (!t.getAttribute('aria-selected')) t.setAttribute('aria-selected', t === on1 ? 'true' : 'false');
      if (t.tagName === 'A') t.setAttribute('role', 'tab');
    });
    r.addEventListener('click', (e) => {
      const t = e.target.closest('[role="tab"]');
      if (!t || !r.contains(t)) return;
      // Ctrl, Cmd, Shift or Alt-click (or a middle click) on a link tab opens its collection the normal way.
      if (t.tagName === 'A' && t.getAttribute('href') && (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
      e.preventDefault();
      if (t.getAttribute('aria-selected') !== 'true') selectTab(r, t, { user: true });
    });
    r.addEventListener('keydown', (e) => {
      const t = e.target.closest && e.target.closest('[role="tab"]');
      if (!t) return;
      const list = tabsOf(r);
      const i = list.indexOf(t);
      let n = -1;
      if (e.key === 'ArrowRight') n = (i + 1) % list.length;
      else if (e.key === 'ArrowLeft') n = (i - 1 + list.length) % list.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = list.length - 1;
      if (n < 0) return;
      e.preventDefault();
      selectTab(r, list[n], { focus: true, user: true });
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (!entries.some((en) => en.isIntersecting)) return;
        io.disconnect();
        prefetch(r);
      }, { rootMargin: '200px 0px' });
      io.observe(r);
    } else {
      prefetch(r);
    }
  }

  /* ------------------------------------------------------------ desktop rail arrows */
  const deskMQ = window.matchMedia ? window.matchMedia('(min-width: 990px) and (hover: hover)') : null;
  let railSeq = 0;
  function railNav(scope) {
    // Rails only: the collection grid (ul.cl-grid, swapped by cl-v2.js) is a wrapping grid and never gets arrows.
    $$('ul[data-hp-cards]:not(.cl-grid)', scope).forEach((ul) => {
      let nav = ul.nextElementSibling && ul.nextElementSibling.classList.contains('hp-rail-nav') ? ul.nextElementSibling : null;
      if (!nav) {
        if (!ul.id) { railSeq += 1; ul.id = `hp-rail-${railSeq}`; }
        nav = d.createElement('div');
        nav.className = 'hp-rail-nav';
        nav.innerHTML = `<button type="button" data-dir="-1" aria-controls="${ul.id}" aria-label="Previous pieces">${svg('left')}</button><button type="button" data-dir="1" aria-controls="${ul.id}" aria-label="Next pieces">${svg('right')}</button>`;
        ul.insertAdjacentElement('afterend', nav);
        nav.addEventListener('click', (e) => {
          const b = e.target.closest('button[data-dir]');
          if (!b) return;
          ul.scrollBy({ left: Number(b.dataset.dir) * Math.max(ul.clientWidth * 0.8, 200), behavior: reduced() ? 'auto' : 'smooth' });
        });
        let raf = 0;
        ul.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => railState(ul, nav)); }, { passive: true });
      }
      railState(ul, nav);
    });
  }
  function railState(ul, nav) {
    const max = ul.scrollWidth - ul.clientWidth;
    const show = !!(deskMQ && deskMQ.matches) && max > 2;
    nav.hidden = !show;
    if (!show) return;
    const [prev, next] = $$('button', nav);
    prev.disabled = ul.scrollLeft <= 2;
    next.disabled = ul.scrollLeft >= max - 2;
  }

  /* ------------------------------------------------------------ list views, wishlist */
  const seenLists = new Set();
  let listIO = null;
  function observeList(el) {
    if (el.__hpLV) return;
    el.__hpLV = true;
    const fire = (t) => {
      const name = t.dataset.hpListView;
      if (!name || seenLists.has(name)) return;
      seenLists.add(name);
      const ids = $$('[data-hp-card]', t).slice(0, 12).map((c) => Number(c.dataset.productId)).filter(Boolean);
      track('hp_list_view', { list: name, ids });
    };
    if (!('IntersectionObserver' in window)) return;
    if (!listIO) {
      listIO = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          listIO.unobserve(en.target);
          fire(en.target);
        });
      }, { threshold: 0.5 });
    }
    listIO.observe(el);
  }
  function syncWish(scope = d) {
    $$('[data-hp-card] [button-wishlist]', scope).forEach((b) => b.setAttribute('aria-pressed', b.classList.contains('active') ? 'true' : 'false'));
  }
  // After a heart is toggled (wishlist.js updates only the clicked button), every hp heart for the same piece
  // follows localStorage 'shopify-wishlist', so a second rail never shows a stale state that would un-save on tap.
  function wishFromStore() {
    let saved = null;
    try { saved = String(localStorage.getItem('shopify-wishlist') || '').split(',').filter(Boolean); } catch (e) { /* storage blocked */ }
    if (saved) $$('[data-hp-card] [button-wishlist]').forEach((b) => b.classList.toggle('active', saved.includes(b.dataset.productHandle)));
    syncWish();
  }

  // Panels filled by other scripts (hp-tab-rail's own loader): re-scan what they insert (list views, wishlist, arrows).
  let panelMO = null;
  function watchPanel(el) {
    if (el.__hpMO || !('MutationObserver' in window)) return;
    el.__hpMO = true;
    if (!panelMO) {
      panelMO = new MutationObserver((recs) => {
        const seen = new Set();
        recs.forEach((r) => r.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          const host = n.matches('[data-hp-cards]') ? n.parentElement : (n.querySelector('[data-hp-cards]') ? n : null);
          if (host && !seen.has(host)) { seen.add(host); scanInserted(host); }
        }));
      });
    }
    panelMO.observe(el, { childList: true, subtree: true });
  }
  function scanInserted(host) {
    $$('a[data-hp-add]', host).forEach((a) => a.setAttribute('role', 'button'));
    $$('[data-hp-list-view]', host).forEach(observeList);
    wishFromStore();
    railNav(host);
    // Rotating offer lines in a lazy panel join the page phase once (COLLECTION-SPEC 3.3; card-badges.js may be absent).
    if (window.CardBadges) window.CardBadges.sync(host);
  }

  /* ------------------------------------------------------------ scan (initial page, inserted panels, editor reloads) */
  function scan(scope = d) {
    try {
      $$('a[data-hp-add]', scope).forEach((a) => { if (a.getAttribute('role') !== 'button') a.setAttribute('role', 'button'); });
      $$('[data-hp-tabset]', scope).forEach(initTabs);
      $$('[data-hp-panel], [data-hp-panels]', scope).forEach(watchPanel);
      $$('[data-hp-list-view]', scope).forEach(observeList);
      if (scope !== d) {
        try { if (typeof initButtons === 'function') initButtons(); } catch (e) { /* wishlist.js absent */ }
        wishFromStore();
        // Inserted cards (lazy tab panels, editor reloads): their offer lines start still (cb-wait) until card-badges.js
        // observes them, so hand the new scope to it (fixer cbfix1).
        if (window.CardBadges) { try { window.CardBadges.sync(scope); } catch (e) { /* noop */ } }
      } else syncWish(scope);
      railNav(scope);
    } catch (e) {
      console.error('[HPv2] scan', e);
    }
  }

  /* ------------------------------------------------------------ delegated listeners */
  function extras(el) {
    const out = {};
    Object.keys(el.dataset).forEach((k) => {
      if (k.length < 3 || k.slice(0, 2) !== 'hp' || k === 'hpTrack' || k === 'hpListView') return;
      let key = k.charAt(2).toLowerCase() + k.slice(3);
      if (key === 'pos') key = 'position';
      const v = el.dataset[k];
      out[key] = /^\d+$/.test(v) ? Number(v) : v;
    });
    return out;
  }
  function trackEl(el) {
    const data = extras(el);
    const card = el.closest('[data-hp-card]');
    if (card) {
      if (data.list === undefined) data.list = card.dataset.list;
      if (data.position === undefined) data.position = Number(card.dataset.position) || 0;
      data.product_id = Number(card.dataset.productId) || 0;
    }
    track(el.dataset.hpTrack, data);
  }

  d.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const add = t.closest('[data-hp-add]');
    if (add) {
      if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // new tab or window: follow the PDP link
      e.preventDefault();
      cardAdd(add);
      return;
    }
    const tr = t.closest('[data-hp-track]');
    if (tr && tr.tagName !== 'DETAILS' && tr.tagName !== 'FORM') trackEl(tr);
    const cart = t.closest('[data-hp-open-cart]');
    if (cart) {
      const drawer = d.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open(cart);
      }
    }
    const opener = t.closest('[data-hp-dialog-open]');
    if (opener) {
      const dlg = d.getElementById(opener.dataset.hpDialogOpen);
      if (dlg) { e.preventDefault(); openDialog(dlg, opener); }
    }
    const closer = t.closest('[data-hp-dialog-close]');
    if (closer) {
      const dlg = closer.closest('dialog');
      if (dlg) { e.preventDefault(); closeDialog(dlg); }
    }
    if (t.closest('[data-hp-card] [button-wishlist]')) setTimeout(wishFromStore, 0);
    else if (t.closest('[button-wishlist]')) setTimeout(() => syncWish(), 0);
  }, true);

  d.addEventListener('keydown', (e) => {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    const a = e.target && e.target.closest && e.target.closest('a[data-hp-add]');
    if (!a) return;
    e.preventDefault();
    a.click();
  });

  d.addEventListener('toggle', (e) => {
    const el = e.target;
    if (!el || el.tagName !== 'DETAILS' || !el.open || !el.dataset.hpTrack) return;
    const data = extras(el);
    if (el.dataset.hpTrack === 'hp_faq_open' && data.question === undefined) {
      const s = el.querySelector('summary');
      if (s) data.question = s.textContent.trim().slice(0, 120);
    }
    track(el.dataset.hpTrack, data);
  }, true);

  d.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f || f.tagName !== 'FORM' || !f.dataset.hpTrack) return;
    const q = f.querySelector('[name="q"]');
    track(f.dataset.hpTrack, Object.assign(extras(f), { q_length: q ? String(q.value || '').trim().length : 0 }));
  }, true);

  ['shopify-wishlist:updated', 'shopify-wishlist:init-buttons'].forEach((n) => d.addEventListener(n, () => syncWish()));
  d.addEventListener('shopify:section:load', (e) => scan(e.target));
  if (deskMQ && typeof deskMQ.addEventListener === 'function') deskMQ.addEventListener('change', () => railNav(d));

  on('hp:added', () => refreshBag());
  on('pdp:added', () => refreshBag());
  try {
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
        const c = payload && payload.cartData;
        refreshBag(c && typeof c.item_count === 'number' ? c.item_count : undefined);
      });
    }
  } catch (e) { /* pubsub.js absent */ }

  /* ------------------------------------------------------------ public API */
  const api = {
    addToCart,
    openQuickAdd,
    money,
    track,
    on,
    emit,
    fetchCards,
    openDialog,
    closeDialog,
    refreshBag,
    live,
    scan,
    version: '1.0.2',
  };
  window.HPv2 = api;

  liveEl();
  scan(d);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', () => setTimeout(wishFromStore, 0));
  else setTimeout(wishFromStore, 0);
  api.ready = true;
  emit('hp:ready', { HPv2: api });
})();
